import React from "react";
import checkMarkIcon from "../Images/check-mark-icon.png";

/** Renders an icon denoting a check-mark. */
export function CheckMarkIcon(): JSX.Element {
    return <img className="check-mark-icon" src={checkMarkIcon} alt="x" width="8" height="8" aria-label="Check mark" />;
}
